import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ApiCrearPeriodo, ApiEditarPeriodo } from "../../../api/periodos";
import { socket } from "../../../config/socket";
const CrearPeriodos = ({
  updateListFn,
  state,
  setState,
  type,
  setType,
  resetState,
}) => {
  const [loading, setlLoading] = useState(false);
  const fields = [
    { name: "nombre", label: "Nombre del Periodo" },
    { name: "fecha_inicio", label: "Fecha de Inicio" },
    { name: "fecha_fin", label: "Fecha de Fin" },
  ];

  const onchange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // SCOCKET REAL TIME
  useEffect(() => {
    // Conectar
    //socket.connect();
    if (!socket.connected) {
      socket.connect();
    }

    socket.emit("join:ticket", "ticketPeriodos");

    // Cleanup
    return () => {
      socket.disconnect();
    };
  }, []);

  const emptyFields = fields.filter((campo) => !state[campo.name]);
  const CrearFn = async () => {
    setlLoading(true);
    if (emptyFields.length > 0) {
      const mensajes = emptyFields.map(
        (campo) => `El campo "${campo.label}" no puede estar vacío.`
      );
      const mensajeError = mensajes.join("\n");
      toast.error(mensajeError, {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    const res =
      type === "save"
        ? await ApiCrearPeriodo(state)
        : await ApiEditarPeriodo(state);
    const datares = res;
    if (datares.sms === "ok") {
      toast.success(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      socket.emit("ticket:update", {
        sala: "ticketPeriodos",
      });
      setType("save");
      resetState();
      updateListFn();
    } else {
      toast.error(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setlLoading(false);
  };

  return (
    <div>
      <div className="row mt-3 mb-4">
        <div className="col-md-6 col-lg-4  w-100">
          <div
            className=" bg-white  border-0 borde-tarjeta"
            style={{ height: "auto" }}
          >
            <div className="card-body m-0 p-0">
              <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                <div className="w-100  d-flex justify-content-between align-items-center px-3">
                  <h5 className=" negrita card-title">
                    {type === "save" ? "Crear" : "Editar"} Periodo
                  </h5>
                  <div className="d-flex justify-content-between flex-row align-self-start">
                    <div className="d-flex justify-content-end ">
                      {loading ? (
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => CrearFn()}
                        >
                          <i className="fas fa-save mx-2"></i>
                          {type === "save" ? "Guardar" : "Editar"} Periodo
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row py-4 ">
                <div className="col-md-6">
                  <label className="py-2 negrita">Nombre del Periodo</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={state.nombre}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el nombre del Periodo"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Fecha de Inicio</label>
                  <input
                    type="date"
                    id="fecha_inicio"
                    name="fecha_inicio"
                    value={state.fecha_inicio}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite la fecha de inicio"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Fecha de Fin</label>
                  <input
                    type="date"
                    id="fecha_fin"
                    name="fecha_fin"
                    value={state.fecha_fin}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite la fecha de fin"
                    onChange={onchange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrearPeriodos;
